<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="pt-subscribe__action-container">
    <template v-if="conditionalButtonCertificate">
      <p class="text-base font-bold mb-4">
        {{ $t('formation.courses.material.getCertificate') }}
      </p>
      <span class="text-base text-gray block mb-10">
        {{ $t('formation.courses.inscription.requestCertificateText') }}
      </span>
      <button
        class="btn btn__outline--blue w-full text-sm justify-center"
        type="button"
        @click="
          course.event_features.content_request_certificate
            ? openModal('', 'infoCertificate')
            : openModal(course.title)
        "
      >
        {{ $t('formation.courses.inscription.requestCertificate') }}
      </button>

      <!-- Modals -->
      <modal-wrapper name="formUser" width="500" height="270px">
        <div>
          <ProfileModalDni :user-model="editUser" @saved-dni="openMailto(course.title)" />
        </div>
      </modal-wrapper>
      <modal-wrapper name="infoCertificate" width="500">
        <div class="p-5">
          <markdown class="mb-5" :content="course.event_features.content_request_certificate" />
          <button
            class="btn btn__outline--blue w-full block mx-auto text-sm"
            type="button"
            @click="openMailto(course.title)"
          >
            {{ $t('formation.courses.inscription.requestCertificate') }}
          </button>
        </div>
      </modal-wrapper>
    </template>
  </div>
</template>
<script>
import { EMAIL_FORMATION } from '~/utils/enums';
import { dateIsEarlier, setHour } from '~/utils/helpers/date';
export default {
  name: 'PastEvent',
  props: {
    enrolled: {
      type: Boolean,
      default: false
    },
    showExpiredWebinar: {
      type: Boolean,
      default: false
    },
    dateEnrolled: {
      type: String,
      default: ''
    },
    course: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['enrollEvent'],
  data() {
    const { openMailto, openModal, editUser } = useMailto();
    return {
      EMAIL_FORMATION,
      openMailto,
      openModal,
      editUser
    };
  },
  computed: {
    // Appear only after the event ends and only to people who were registered before the event started.
    conditionalButtonCertificate() {
      const today = new Date();
      const finishDate = setHour(
        this.course?.list_of_sessions?.at(-1)?.date,
        this.course?.list_of_sessions?.at(-1)?.lectures?.at(-1)?.event_time
      );
      const finishEarly = dateIsEarlier(finishDate, today);
      const enrolledEarly = dateIsEarlier(
        this.course?.external_form_integrations?.registration_datetime_limit,
        this.dateEnrolled
      );
      return (
        this.course?.event_features?.show_request_certificate &&
        this.enrolled &&
        !finishEarly &&
        enrolledEarly
      );
    }
  },
  methods: {
    enrollEvent() {
      this.$emit('enrollEvent');
    }
  }
};
</script>
